import type { Theme } from '@mui/material/styles'

import { verdictAccent, verdictIcon, type VerdictOutcome } from './verdictStyles'

/**
 * Значок вердикта рядом с ответом.
 *
 * `className` пробрасываем: `Chip` вешает на свой значок класс `MuiChip-icon`
 * через клонирование, и без него отступы фишки ломаются.
 */
export function VerdictMark({
  outcome,
  fontSize = 'small',
  className,
}: {
  outcome: VerdictOutcome
  fontSize?: 'small' | 'inherit'
  className?: string
}) {
  const Icon = verdictIcon(outcome)

  return (
    <Icon
      className={className}
      fontSize={fontSize}
      sx={(theme: Theme) => ({ color: verdictAccent(theme, outcome), flexShrink: 0 })}
    />
  )
}
